import {Avatar} from "@ui";
import PropTypes from "prop-types";
import {useState} from "react";
// import {useTranslation} from "react-i18next";
import {getUserAvatarImage, getUserInitials} from "../../util/avatarUtils";

const UserProfileAvatar = ({user, size = 100}) => {
  const [imageError, setImageError] = useState(false);
  const avatarImage = getUserAvatarImage(user);
  const userInitials = getUserInitials(user);

  const handleImageError = () => setImageError(true);

  // const {t} = useTranslation();

  // Upload props
  // const uploadProps = {
  //   showUploadList: false,
  //   beforeUpload: (file) => {
  //     const isJpgOrPng =
  //       file.type === "image/jpeg" ||
  //       file.type === "image/png" ||
  //       file.type === "image/jpg";
  //     if (!isJpgOrPng) {
  //       notification.warning({
  //         message: t("userProfileImageFormat"),
  //         description: t("userProfileImageFormatDesc"),
  //       });
  //       return false;
  //     }
  //     const isLt3M = file.size / 1024 / 1024 < 3;
  //     if (!isLt3M) {
  //       notification.warning({
  //         message: t("userProfileImageSize"),
  //         description: t("userProfileImageSizeDesc"),
  //       });
  //       return false;
  //     }

  //     onUpload?.(file);
  //     return false;
  //   },
  // };

  return (
    <div style={{position: "relative", display: "inline-block"}}>
      <Avatar
        size={size}
        style={{background: "var(--surface-2)"}}
      >
        {!imageError && avatarImage ? (
          <img
            src={avatarImage}
            alt="User Avatar"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "50%",
            }}
            onError={handleImageError}
          />
        ) : (
          userInitials
        )}
      </Avatar>
      {/* <Upload
        {...uploadProps}
        style={{position: "absolute", bottom: 0, right: 0}}
      >
        <Tooltip
          title={t("userProfileImageEdit")}
          overlayClassName="edit-tooltip"
        >
          <span
            style={{
              position: "absolute",
              bottom: 0,
              right: 0,
              background: "var(--theme-surface-white)",
              borderRadius: "50%",
              padding: 6,
              boxShadow: "0 0 4px rgba(0,0,0,0.15)",
              cursor: "pointer",
              border: "1px solid var(--theme-border-medium)",
            }}
          >
            <svg
              width={size / 5}
              height={size / 5}
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              role="img"
              aria-label={t ? t("userProfileImageEdit") : "Edit avatar"}
            >
              <path
                d="M3 17.25V21h3.75l11.06-11.06-3.75-3.75L3 17.25z"
                fill="var(--surface-3)"
              />
              <path
                d="M20.71 7.04a1.003 1.003 0 0 0 0-1.42l-2.34-2.34a1.003 1.003 0 0 0-1.42 0l-1.83 1.83 3.75 3.75 1.84-1.82z"
                fill="var(--surface-3)"
              />
            </svg>
          </span>
        </Tooltip>
      </Upload> */}
    </div>
  );
};

UserProfileAvatar.propTypes = {
  user: PropTypes.object,
  size: PropTypes.number,
  onUpload: PropTypes.func,
};

export default UserProfileAvatar;
